import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { CONTACT } from '../../data/modalities';
const USED_EQUIPMENT_IMAGE = 'https://asset.imagine.art/video/thumbnails/23882006-c9b8-4272-9538-62b6c951ddca';
export function UsedEquipment() {
  return <section id="used-equipment" className="w-full bg-slate-50 py-20 sm:py-24" data-id="element-765" data-mp="282bbwpha8bpn">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-766" data-mp="234ji1px2ufit">
        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 shadow-[0_20px_50px_-28px_rgba(26,27,75,0.28)] sm:p-12" data-id="element-767" data-mp="1z37rni6dpq9k">
          <div className="grid items-center gap-10 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-768" data-mp="1ub6iw68f6hoa">
            <div className="aspect-[4/3] overflow-hidden rounded-2xl bg-slate-50" data-id="element-769" data-mp="1peg1nfkvpg1a">
              <img src={USED_EQUIPMENT_IMAGE} alt="Pre-owned therapeutic modality equipment being evaluated in a clean clinic" className="h-full w-full object-cover" data-id="element-770" data-mp="1kfcw7u0zl7ss" />
            </div>
            <div data-id="element-771" data-mp="1bfzvpquubtk7">
              <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-772" data-mp="2j7dp5y51ped7">
                USED EQUIPMENT
              </p>
              <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-773" data-mp="2nz5fq8o7bk3c">
                Pre-owned modalities, evaluated before you buy
              </h2>
              <p className="mt-5 text-[16px] leading-relaxed text-charcoal/75" data-id="element-774" data-mp="2e92h9syb9dxm">
                When the right system becomes available, JAG helps doctors look
                beyond price alone. We help compare the equipment type, intended
                use, condition questions, serviceability, training needs, and
                whether the opportunity actually fits the practice.
              </p>
              <p className="mt-4 text-sm leading-relaxed text-charcoal/60" data-id="element-775" data-mp="2wx7e0ggjvymx">
                Availability changes often, so the first step is a conversation.
                Ask JAG what is currently worth considering across laser,
                shockwave, light therapy, imaging, and other modality categories.
              </p>
              <a href={CONTACT.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-776" data-mp="3o84wzt7qxog2">
                <PhoneIcon className="h-[18px] w-[18px]" data-id="element-777" data-mp="35g2lsxdvj0d7" />
                Call About Used Equipment
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}